<template><div><h1 id="telefonmarketing-alnovis-parametrisierung" tabindex="-1"><a class="header-anchor" href="#telefonmarketing-alnovis-parametrisierung"><span>Telefonmarketing (Alnovis) Parametrisierung</span></a></h1>
<p>Telefonmarketing (Alnovis) Parametrisierung — Parametrisierung für Telefonmarketing (Alnovis)</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In dieser Tabelle wird die Parametrisierung für den Austausch der Daten zwischen funtrade und Alnovis vorgenommen.</p>
<p>Pfad: <code v-pre>Systemverwaltung → Tabellen → Systemtabellen → Parametrisierung TM Alnovis</code></p>
<h2 id="datenfelder-resultat-codes" tabindex="-1"><a class="header-anchor" href="#datenfelder-resultat-codes"><span>Datenfelder (Resultat-Codes)</span></a></h2>
<dl>
<dt>Resultat-Code</dt>
<dd>Resultat-Code, definiert von Alnovis.</dd>
<dt>Ereignis erfassen</dt>
<dd>Ereignis erfassen ja/nein (Ereignis wird durch Alnovis in einer vordefinierten Spalte geliefert).</dd>
<dt>Status</dt>
<dd>Ereignis-Status für das importierte Ereignis, Auswahl aus Wertetabelle (nur verwendbar wenn Ereignis erfassen auf ja steht).</dd>
<dt>Kanal</dt>
<dd>Kommunikationskanal für das importierte Ereignis, Auswahl aus Wertetabelle (nur verwendbar wenn Ereignis erfassen auf ja steht).</dd>
<dt>Ereignis mit Wert</dt>
<dd>Responsewert für das importierte Ereignis (Responsewert wird durch Alnovis in einer vordefinierten Spalte geliefert).</dd>
<dt>Telefonnummer importieren</dt>
<dd>Telefonnummer der Person importieren, (Telefonnummer wird durch Alnovis in einer vordefinierten Spalte geliefert).</dd>
<dt>Bezeichnung</dt>
<dd>Freie Bezeichnung für die definierte Zeile als Beschreibung.</dd>
</dl>
<h2 id="datenfelder-parameter" tabindex="-1"><a class="header-anchor" href="#datenfelder-parameter"><span>Datenfelder (Parameter)</span></a></h2>
<dl>
<dt>Priorität</dt>
<dd>Beim Import der Daten wird die Definition nach Priorität (von oben nach unten, bzw. alphanumerisch aufsteigend) verarbeitet.</dd>
<dt>Spaltenname</dt>
<dd>Definition der variablen Spalten zwischen <span class="emphasis"><em><span class="application">funtrade</span></em></span> und Alnovis, wobei die Definition &quot;Resultat&quot; die Resultat-Codes-Tabelle referenziert.</dd>
<dt>Wert</dt>
<dd>Wenn Spaltenname = Resultat ist, wird das Feld &quot;Resultat-Code&quot; in der Resultat-Codes-Tabelle referenziert, ansonsten der Wert für eine andere Spalte.</dd>
<dt>Personenmerkmal</dt>
<dd>Erfassen des ausgewählten Personenmerkmals aus der Wertetabelle.</dd>
<dt>Publikation hinzufügen</dt>
<dd>Hinzufügen der ausgewählten Publikation aus der Wertetabelle.</dd>
<dt>Publikation entfernen</dt>
<dd>Entfernen der ausgewählten Publikation aus der Wertetabelle.</dd>
<dt>Protokoll</dt>
<dd>Protokollieren der Verarbeitung.</dd>
<dt>Bezeichnung</dt>
<dd>Freie Bezeichnung für die definierte Zeile als Beschreibung.</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/schnittstelle/telefonmarketing.html" title="8. Telefonmarketing (Alnovis)">Telefonmarketing (Alnovis)</RouteLink> , <RouteLink to="/referenz/refs/ft.refdata.tm-alnovis.html" title="Telefonmarketing (Alnovis) Export/Import">Telefonmarketing (Alnovis) Export/Import</RouteLink> , <RouteLink to="/referenz/refs/ft.refproc.tmalnovisexportieren.html" title="Alnovis - Segmentierungsdatei exportieren...">Alnovis - Segmentierungsdatei exportieren...</RouteLink> , <RouteLink to="/referenz/refs/ft.refproc.tmalnovisimportieren.html" title="Alnovis - Datei importieren...">Alnovis - Datei importieren...</RouteLink></p>
</div></template>


